import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import { PiPlayCircle } from 'react-icons/pi';

export const ReferenceVideo = ({
  url,
  image,
  className,
}: {
  url: string;
  image: string;
  className?: { container?: string };
}) => {
  return (
    <Link
      prefetch={false}
      target="_blank"
      href={url}
      className={cn(
        'relative h-[250px] w-screen sm:my-8 sm:h-[450px] md:h-[600px]',
        className?.container,
      )}
    >
      <div className="absolute left-1/2 top-1/2 z-[5] flex aspect-square w-24 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-primary/60 backdrop-blur-sm lg:w-32">
        <PiPlayCircle size={48} className="text-white" />
      </div>
      <Image
        src={image}
        alt="Video"
        fill
        style={{ objectFit: 'cover', objectPosition: 'center' }}
        sizes="100vw"
        quality={100}
        className="absolute inset-0 z-0 h-full w-full"
      />
    </Link>
  );
};
